<template>
	<span class="content">
		<Username :user="message.from" />
		{{ modeVerb }}
		<ParsedMessage :message="message" />
	</span>
</template>

<script lang="ts">
import {defineComponent, PropType, computed} from "vue";
import {ClientNetwork, ClientMessage} from "../../js/types";
import ParsedMessage from "../ParsedMessage.vue";
import Username from "../Username.vue";

export default defineComponent({
	name: "MessageTypeMode",
	components: {
		ParsedMessage,
		Username,
	},
	props: {
		network: {
			type: Object as PropType<ClientNetwork>,
			required: true,
		},
		message: {
			type: Object as PropType<ClientMessage>,
			required: true,
		},
	},
	setup(props) {
		// ЛАФЧЕ.ORG: превод "sets mode" - бан (b) е специален случай,
		// всичко останало (потребителски флагове o/v/h/a, чан-настройки
		// i/m/l/k/s/p) е генерично "флаг"
		const modeVerb = computed(() => {
			const text = props.message.text || "";
			const isAdd = text[0] === "+";
			const modeLetters = text.split(" ")[0] || "";
			const isBan = modeLetters.includes("b");

			if (isBan) {
				return isAdd ? "сложи бан" : "премахна бан";
			}

			return isAdd ? "сложи флаг" : "премахна флаг";
		});

		return {
			modeVerb,
		};
	},
});
</script>
